enum CountryBillingType {
  Argentina = 1,
  Brasil = 2,
}

export default CountryBillingType;
